import React, { useState } from 'react';
import logo75 from '../assets/images/75Years.png';
import logo from '../assets/images/logo.png';
//benifits images
import understanding from '../assets/images/understanding.png';
import accuracy from '../assets/images/accuracy.png';
import analytics from '../assets/images/analytics.png';
import advice from '../assets/images/advice.png';
import evaluate from '../assets/images/evaluate.png';
import vision from '../assets/images/vision.png';

import colorCoded from '../assets/images/color-coded-parameter.png';
import criticalparameter from '../assets/images/critical-paramater.png';
import historictrends from '../assets/images/historic-trends.png';
import dietrecommendation from '../assets/images/diet-rec.png';
import lifestylerecommendation from '../assets/images/lifestyle-rec.png';
import immediatetest from '../assets/images/immediate-su-test.png';

const Benefits = () => {
    return (
        <>
            <section className="section section-2" id='benefits'>
                <div className="container">
                    <div className="row">
                        <div className="col d-flex align-items-center pt-2 pb-2 header">
                            <div>
                                <img className="img-fluid logo-75" src={logo75} />
                            </div>
                            <div className="ms-auto">
                                <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="benefits page-padding page-padding">
                            <div className="col-12 text-center">
                                {/* <h2 className="title">What benefits will <br />
                                    you unlock with this report?</h2> */}
                                <h2 className='title'>Benefits of <span>Smart Report</span></h2>
                            </div>
                            <div className="row  d-flex justify-content-center">
                                <div className="col-10 col-lg-8 text-center desc">
                                {/* Dr Lal PathLabs Smart Report is a blend of 75 years of diagnostic services and expertise of our medical technicians. The Smart report is further enhanced by Artificial Intelligence, to create personalized and easy-to-understand health information. The reports are available digitally on WhatsApp and on our website. */}
                                 {/* <span> AI insights and expert comments.</span> */}
                                 Dr Lal PathLabs Smart Report is a blend of 75+ years of diagnostic services and expertise of the  medical team.
The Smart report is further enhanced by Artificial Intelligence, to create a personalized and easy-to-understand health report. The reports are available digitally on WhatsApp and on our website. 
                                </div>
                            </div>
                            <div className="row pb-5" >
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 benifits-steps">
                                    <div className="row mb-3">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 step-1">
                                            <div className="step-wrapper">
                                                <div className="word-wrapper">
                                                    A
                                                </div>
                                                <div className="content-wrapper">
                                                    <h2>Colour Coded Parameters</h2>
                                                    <div>Highlights the concern areas of health parameters in different colors for easy understanding.</div>
                                                    {/* <div>Highlights deficiencies and critical health markers in different colours to get your instant focus.</div> */}
                                                </div>
                                                <div className="img-wrapper">
                                                    <img alt="" src={colorCoded} className="img-responsive" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="offset-md-6 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 step-2">
                                            <div className="step-wrapper">
                                                <div className="img-wrapper">
                                                    <img alt="" src={criticalparameter} className="img-responsive" />
                                                </div>

                                                <div className="content-wrapper">
                                                    <h2>Critical Parameters Segregation</h2>
                                                    <div>In-depth explanation of "Out of range" parameters and its impact.</div>
                                                </div>
                                                <div className="word-wrapper">
                                                    B
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 step-3">
                                            <div className="step-wrapper">
                                                <div className="word-wrapper">
                                                    C
                                                </div>
                                                <div className="content-wrapper">
                                                    <h2>Historic Trend</h2>
                                                    <div>Graphical and tabular trends to analyse historical data. Enables doctors to view past trends at one place.</div>
                                                </div>
                                                <div className="img-wrapper">
                                                    <img alt="" src={historictrends} className="img-responsive" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="offset-md-6 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 step-4">
                                            <div className="step-wrapper">
                                                <div className="img-wrapper">
                                                    <img alt="" src={dietrecommendation} className="img-responsive" />
                                                </div>

                                                <div className="content-wrapper">
                                                    <h2>Diet Recommendations</h2>
                                                    <div>Personalized diet suggestions based on diagnostics requirements curated by dieticians.</div>
                                                </div>
                                                <div className="word-wrapper">
                                                    D
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 step-5">
                                            <div className="step-wrapper">
                                                <div className="word-wrapper">
                                                    E
                                                </div>
                                                <div className="content-wrapper">
                                                    <h2>Personalized Lifestyle Recommendations</h2>
                                                    <div>Tailored lifestyle advice based on individual’s health markers.</div>
                                                </div>
                                                <div className="img-wrapper ms-auto">
                                                    <img alt="" src={lifestylerecommendation} className="img-responsive" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="offset-md-6 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 step-6">
                                            <div className="step-wrapper">
                                                <div className="img-wrapper">
                                                    <img alt="" src={immediatetest} className="img-responsive" />
                                                </div>

                                                <div className="content-wrapper">
                                                    <h2>Suggestive Tests</h2>
                                                    <div>Recommendations of tests as per current test values<sup>#</sup> </div>
                                                    {/* <div>Recommendations for tests as needed<sup>#</sup> </div> */}
                                                </div>
                                                <div className="word-wrapper">
                                                    F
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* <div className="row " style={{marginTop: 150 + 'px'}}>
                                <div className="col-12 d-flex " style={{alignItems: end}}>
                                <div>
                                        <img alt="" src="qr.PNG" style={{ maxWidth: 80 + 'px'}} />
                                    </div> 
                                    <div style={{ paddingLeft: 15 + 'px'}}>
                                        Scan this QR code for<br />
                                        a voice summary of <br />
                                        your smart report
                                    </div>
                                </div>
                            </div> */}

                            <div className='row mt-5'>
                                <div className='container-1'>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                    <p className='fst-italic mb-2'>*Historical data , if the tests done at Dr Lal Pathlabs </p>
                                    <p className='fst-italic mb-2'># Doctors / specialist consultation is recommended before booking any test </p>
                                </div>
                                </div>
                                
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Benefits;
